export function pointInEllipseFill(cx, cy, rx, ry, x, y) {
    return Math.pow((x - cx), 2) / Math.pow(rx, 2) + Math.pow((y - cy), 2) / Math.pow(ry, 2) <= 1;
}
export function pointInEllipseStroke(cx, cy, rx, ry, lineWidth, x, y) {
    return (pointInEllipseFill(cx, cy, rx + lineWidth / 2, ry + lineWidth / 2, x, y) &&
        !pointInEllipseFill(cx, cy, rx - lineWidth / 2, ry - lineWidth / 2, x, y));
}
